import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../../services/analytics';
import { useAppSelector } from '../../store/hooks';

// Sign-in pages carry auth codes, not navigation, and run before a session exists.
const SIGN_IN_PATH_PREFIXES = ['/login', '/auth/', '/oauth/'];

// MEN-5426: one general page view per path, so arrival UTMs are captured on every
// coach and admin page, not only the screens with a named view event.
export function usePageViewTracking(): void {
  const authStatus = useAppSelector((s) => s.auth.status);
  const { pathname } = useLocation();
  const lastTrackedPathname = useRef<string | null>(null);

  useEffect(() => {
    if (authStatus !== 'authenticated') return;
    if (SIGN_IN_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))) return;
    if (lastTrackedPathname.current === pathname) return;

    lastTrackedPathname.current = pathname;
    analytics.track(
      'Viewed page',
      { route: pathname },
      { queryParams: Object.fromEntries(new URLSearchParams(window.location.search)) }
    );
  }, [authStatus, pathname]);
}
